import { axios } from '@Api/axiosClient';

export interface InvitationResult {
    status: 'accepted' | 'invalid';
}

export interface DashboardSessionResult {
    status: 'ready' | 'invalid';
    dealId?: string;
}

export const acceptInvitationApi = async (token: string): Promise<InvitationResult> => {
    const response = await axios.post('api/Invitation/AcceptInvitation', { token });
    return response.data;
};

// Accepts the invitation AND seeds the client hub activity session with dashboard context
// + recipient details (phone/email) so the downstream auth flow can build a LoginHint.
// Prefer this over acceptInvitationApi for the invite landing page — AcceptInvitation alone
// only flips participant.Status and leaves the session identityless, which breaks the OTP flow.
export const prepareDashboardSessionApi = async (token: string): Promise<DashboardSessionResult> => {
    // NOTE: the action is named `PrepareDashboardSessionAsync` in C# but ASP.NET Core strips the
    // `Async` suffix from route generation by default, so the exposed path is `.../PrepareDashboardSession`.
    const response = await axios.post('api/ActivitySession/PrepareDashboardSession', {
        invitationToken: token,
    });
    return response.data;
};
